import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-exception-confirm',
  templateUrl: './modal-exception-confirm.component.html',
  styleUrls: ['./modal-exception-confirm.component.css']
})
export class ModalExceptionConfirmComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalExceptionConfirmComponent>) { }

  ngOnInit() {
  }


  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }
}
